import { Injectable, ComponentRef, Provider } from '@angular/core';
import { IUserPasswordSetDialogService, IUserPasswordSetDialogServiceToken } from 'shared/services/ui/dialogs/user-password-set/user-password-set-dialog-service.abstract';
import { DialogBaseService } from 'projects/shared/lib/services/ui/dialog.service';
import { UserPasswordSetDialogMHComponent } from '../../components/shared/user/password-set-dialog/user-password-set-dialog.component';

@Injectable({
  providedIn: 'root',
}) export class UserPasswordSetDialogService implements IUserPasswordSetDialogService {

  passwordSetDialogShow(
    modalTitle: string,
    callbackSubmit: () => void,
    callbackCancel: () => void,
    submitButtonLabel?: string,
    cancelButtonLabel?: string,
  ) {
    DialogBaseService.dialogGenericShow(
      UserPasswordSetDialogMHComponent,
      (component: ComponentRef<UserPasswordSetDialogMHComponent>) => {
        component.instance.modalTitle = modalTitle;
        if (submitButtonLabel) {
          component.instance.submitButtonLabel = submitButtonLabel;
        }
        if (cancelButtonLabel) {
          component.instance.cancelButtonLabel = cancelButtonLabel;
        }

        component.instance.modalSubmit.subscribe(
          () => {
            callbackSubmit();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
        component.instance.modalCancel.subscribe(
          () => {
            callbackCancel();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
      }
    );
  }

}
/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const UserPasswordSetDialogServiceProvider: Provider[] = [
  { provide: IUserPasswordSetDialogServiceToken, useExisting: UserPasswordSetDialogService }
];

